import { Box, Button, MessageBlock } from '@deckee/deck-hand';
import React, { FC } from 'react';
import styled from 'styled-components';

const StyledButton = styled(Button)`
  color: ${({ theme }) => theme.colors.black};
  padding-top: ${({ theme }) => `${theme.space[3]}px`};
  white-space: break-spaces;
  font-size: 12px;
  width: 100%;
  display: block;
  text-decoration: underline;
`;

interface VerifyEmailProps {
  email: string;
  retry: () => void;
}

const VerifyEmail: FC<VerifyEmailProps> = ({ email, retry }) => (
  <Box pt="3">
    <MessageBlock type="success">
      {`Tap the link in the email we just sent to `}
      <Box as="span" fontWeight="bold">
        {email}
      </Box>
      {` to sign in securely.`}
      <br />
      <br />
      <Box as="span" fontWeight="bold">
        {`Didn't receive it? `}
      </Box>
      Check your junk/spam folder, thanks!
    </MessageBlock>
    <StyledButton link onClick={retry} lineHeight="1">
      Didn&apos;t receive an email? Try a different one instead.
    </StyledButton>
  </Box>
);

export default VerifyEmail;
